import { DEFAULT_ANNOTATION_FRAME_COLOR } from "pages/MaterialSpecs/components/PreviewSelector";
import {
    ApiAnnotation,
    ApiUpdateAnnotation,
    Annotation,
    AnnotationType,
    Position,
} from "store/features/annotations/interfaces";
import { customAlphabet } from "nanoid";
import { AssetType } from "api/assets";
import { millisecondsToSeconds, secondsToMilliseconds } from "utils";

const nanoid = customAlphabet("1234567890", 18);

export const createNewAnnotation = (
    type: AnnotationType,
    creator: string,
    position: Position,
    userId: number,
    assetId?: number,
    timeStampSeconds?: number,
    assetType: AssetType = assetId ? "VISUAL" : "DEFAULT"
) => {
    return {
        type,
        creator,
        position,
        id: 0, // required by backend for new annotations to have id: 0
        selectionId: Number.parseInt(nanoid()),
        color: DEFAULT_ANNOTATION_FRAME_COLOR,
        comment: "",
        date: "",
        internal: false,
        reviewed: false,
        modified: true,
        permissions: [],
        creatorId: userId,
        assetType,
        timeStampSeconds,
    };
};

export const buildAnnotation = (
    {
        // eslint-disable-next-line
        type_enum,
        id,
        signals,
        color,
        text,
        creator,
        modificationtime,
        page,
        internal,
        marked,
        permissions,
        creatorid,
        assetFileName,
        assetid,
    }: ApiAnnotation,
    assetType: AssetType
): Annotation => {
    return {
        assetType,
        page,
        internal,
        permissions,
        id,
        creatorId: creatorid,
        selectionId: id,
        position: signals[0],
        timeStampSeconds:
            signals[0].startMillisecond !== undefined ? millisecondsToSeconds(signals[0].startMillisecond) : undefined,
        color: color.replace("0#", "#"), //backend doesn't know why hex color is returned prefixed with 0...
        comment: text,
        type: type_enum,
        creator: creator.name,
        date: modificationtime,
        reviewed: marked,
        modified: false,
        attachedAsset:
            assetid && assetFileName
                ? {
                      id: assetid,
                      fileName: assetFileName,
                  }
                : undefined,
    };
};

export const buildApiAnnotation = ({
    id,
    color,
    comment,
    type,
    page,
    reviewed,
    attachedAsset,
    position: { x, y, width, height },
    timeStampSeconds,
}: Annotation): ApiUpdateAnnotation => {
    return {
        id,
        color,
        type,
        reviewed,
        asset: attachedAsset?.id,
        page,
        text: comment,
        position: { x, y, w: width, h: height },
        internal: false,
        startMillisecond: timeStampSeconds !== undefined ? secondsToMilliseconds(timeStampSeconds) : undefined,
    };
};

export const buildAnnotationsModel = (annotations: ApiAnnotation[], assetType: AssetType): Annotation[] => {
    return annotations.map((annotation) => buildAnnotation(annotation, assetType));
};

export const buildAnnotationsApiModel = (annotations: Annotation[]): ApiUpdateAnnotation[] => {
    return annotations.map(buildApiAnnotation);
};
